import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DocumentResourceService } from '../../../shared/services/document-resource.service'
import { PrincipalService } from '../../../shared';
import { GENERAL_CONSTANTS, ROLE_CONSTANTS } from '../../../shared/constants/constant';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.css']

})
export class DocumentComponent implements OnInit {
  public browserLang: string;
  public lang;
  public allowUpload = false;
  public showDocs = false;
  public noDocs = false;
  public noTitle = false;
  public furtherUpload = false;
  public noFile = false;
  public hideModal = true;
  rowCount: number;
  rows;
  columns;
  public success = false;
  error;
  docStatus;
  welcome: string;
  docsData;
  sortKey;
  datCount;
  reverse;
  sendData;
  public docTitle = '';
  active: any;
  language;
  companyCode: any;
  userRole;
  attachFile;
  public searchModel = '';
  public searchQuery = '';
  searchFilter;
  public rowsOnPage = 10;
  public sortBy = 'fileName';
  public sortOrder = 'asc';
  public data;
  public docCodes = [];
  public totalItems;
  public currentPage = 1;
  public pageNumber;
  public pageSize;
  public showCheckBox = false;
  public deleteSuccess = false;
  public deleteError = false;
  ////////////
  public fileCaptionClass = false;
  public fileExtensionClass = false;
  public fileDateClass = false;
  public fileSizeClass = false;
  records: Array<any>;
  isDesc = false;
  column = 'fileCaption';
  direction = 1;

  public selectedProductForSearch = '0';
  public selectedProductForUpload = '0';

  public productList = [
    {
      productId: 1,
      productName: 'DPLK'
    },
    {
      productId: 2,
      productName: 'PPUKP'
    },
    {
      productId: 3,
      productName: 'Saving Plan'
    },
    {
      productId: 4,
      productName: 'GFA / Group Flexi Account'
    }
  ]

  // @ViewChild('mySelectedProduct') mySelectedProduct;


  constructor(private documentResourceService: DocumentResourceService,
              public principalService: PrincipalService,
              private translate: TranslateService) {

    this.lang = translate.currentLang;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.browserLang = event.lang
      this.lang = this.browserLang;
    });
  }

  ngOnInit() {
    this.principalService.identity().then((account) => {
      if (account.authorities.includes(ROLE_CONSTANTS.ROLE_ADMIN) || account.authorities.includes(ROLE_CONSTANTS.ROLE_SUPPORT)) {
        this.allowUpload = true;
      }
    });
    this.pageNumber = 1;
    this.pageSize = 10;
    this.getDocuments();
    this.sort('fileCaption');
  }

  sort(property) {
    this.updateClass(property)
    // this.inSort = true;
    this.isDesc = !this.isDesc; // change the direction
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
  };

  public updateClass(property) {
    if (property === 'fileCaption') {
      this.fileCaptionClass = true;
      this.fileExtensionClass = false;
      this.fileDateClass = false;
      this.fileSizeClass = false;
    }
    if (property === 'extensionUpper') {
      this.fileCaptionClass = false;
      this.fileExtensionClass = true;
      this.fileDateClass = false;
      this.fileSizeClass = false;
    }
    if (property === 'fileDate') {
      this.fileCaptionClass = false;
      this.fileExtensionClass = false;
      this.fileDateClass = true;
      this.fileSizeClass = false;
    }
    if (property === 'fileSize') {
      this.fileCaptionClass = false;
      this.fileExtensionClass = false;
      this.fileDateClass = false;
      this.fileSizeClass = true;
    }
  }

  getDocuments() {
    this.documentResourceService.getDocumentsByKeyword(
      this.searchModel, this.selectedProductForSearch, this.pageNumber, this.pageSize)
      .subscribe((docsData) => {
        this.data = docsData['content'];
        this.totalItems = docsData['totalElements'];
        // this.pageNumber = 1;
        this.pageSize = docsData['size'];
        if (this.data.length >= 1) {

          this.showDocs = true;
          this.noDocs = false;
        } else {
          this.showDocs = false;
          this.noDocs = true;
        }
        this.datCount = this.data.length;
        for (let i = 0; i < this.data.length; i++) {
          let ext = this.getExtension(this.data[i].fileName);
          if (ext !== null && ext !== undefined) {
            ext = ext.toLowerCase();
            this.data[i]['extension'] = ext;
            if (ext !== null && ext !== undefined) {
              this.data[i]['extensionUpper'] = ext.toUpperCase();
            }

            if (ext === 'pdf') {
              this.data[i]['class'] = 'glyphicon-file-pdf';
            } else if (ext === 'xls' || ext === 'xlsx') {
              this.data[i]['class'] = 'glyphicon-file-xls';
            } else if (ext === 'doc' || ext === 'docx') {
              this.data[i]['class'] = 'glyphicon-file-doc';
            } else if (ext === 'ppt' || ext === 'pptx') {
              this.data[i]['class'] = 'glyphicon-file-ppt';
            } else {
              this.data[i]['class'] = '';
            }
          }

        }
      });
  }

  public checkDocByCode(event) {
    const selctedVal = event.target.value;
    if (event.target.checked) {
      this.itemExistsChecker(selctedVal);
      if (this.docCodes.length > 0) {
        this.showCheckBox = true;
      }
    } else {
      // Delete the doc value from the array if its checkbox is unchecked
      const cboxValueIndex = this.docCodes.indexOf(selctedVal);
      if (cboxValueIndex >= 0) {
        this.docCodes.splice(cboxValueIndex, 1);
      }
      if (this.docCodes.length === 0) {
        this.showCheckBox = false;
      }
    }
  }

  // Check if the doc value has already been added to the array and if not - add it
  public itemExistsChecker(cboxValue) {
    const len = this.docCodes.length;
    if (len > 0) {
      for (let i = 0; i < len; i++) {
        if (this.docCodes[i] === cboxValue) {
          return true;
        }
      }
    }
    this.docCodes.push(cboxValue);
  }

  public deleteDocByCode() {
    const deletCodes = this.docCodes.toString();
    this.documentResourceService.deleteDocs(deletCodes).subscribe(
      response => {
        this.deleteSuccess = true;
        this.deleteError = false;
        this.getDocuments();
      },
      (error) => {
        this.deleteError = true;
        this.deleteSuccess = false;
      });
  }

  public getExtension(path) {
    const basename = path.split(/[\\/]/).pop(),  // extract file name from full path ... // (supports `\\` and `/` separators)
      pos = basename.lastIndexOf('.');       // get last position of `.`
    if (basename === '' || pos < 1) {        // if file name is empty or ...
      return '';
    }                             //  `.` not found (-1) or comes first (0)
    return basename.slice(pos + 1);            // extract extension ignoring `.`
  }

  public pageChanged(event: any): void {
    this.docCodes.length = 0;
    this.showCheckBox = false;
    this.pageNumber = event.page;
    this.pageSize = event.itemsPerPage;
    this.getDocuments();
  }

  clearSearchData() {
    if (this.searchModel.length === 0) {
      this.searchModel = '';
      this.getDocuments();
      this.sort('fileCaption');
    }
  }

  clearUploadTitleData() {
    this.docTitle = '';

  }

  clearByClose() {
    this.searchModel = '';
    this.clearSearchData();
  }

  clearBySearchDropdown() {
    this.selectedProductForSearch = '0';
  }

  clearByUploadDropdown() {
    this.selectedProductForUpload = '0';
  }

  onChange(event: any) {
    if (this.docTitle !== '' && this.selectedProductForUpload !== '0') {
      this.success = false;
      this.noTitle = false;
      this.furtherUpload = true;
    }
    if (this.docTitle === '' || this.selectedProductForUpload === '0') {
      this.success = false;
      this.noTitle = true;
      this.furtherUpload = false;
    }

    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);
      this.sendData = {
        title: this.docTitle,
        active: 1,
        language: this.lang,
        companyCode: ''
      };
      formData.append('productId', this.selectedProductForUpload);
      formData.append('title', this.docTitle);
      formData.append('active', '1');
      formData.append('language', this.lang);
      formData.append('companyCode', '');
      if (this.furtherUpload) {
        this.documentResourceService.uploadFile(formData).subscribe(
          data => {
            this.noTitle = false;
            this.docStatus = data;
            if (this.docStatus.status = 200) {
              this.error = null;
              this.success = true;
              this.getDocuments();
              this.docTitle = '';
            } else {
              this.success = false;
              this.error = 'ERROR';
            }
          },
          error => {
            this.success = false;
            this.error = 'INTERROR';
          }
        );
      }
    }
  }

  // selectProduct (productId) {
  //   this.selectedProductId = productId;
  // }

  // onSelect (value) {
  //   // this.selectedProductId = value;
  //   console.log(value);
  // }

  public downloadDocument(downloadCode, title, extension) {
    this.documentResourceService.downloadDocument(downloadCode, title, extension).subscribe((docsData: Blob) => {
      this.noFile = false;
      try {
        const isFileSaverSupported = !!new Blob;
        if (isFileSaverSupported) {
          FileSaver.saveAs(docsData, title + GENERAL_CONSTANTS.DOT + extension);
        } else {
          this.documentResourceService.downloadDataDetail(downloadCode);
        }
      } catch (e) {
        console.log('Error : ' + e);
      }
    }, (err) => {
      this.noFile = true;
    });
  }
}
